import 'twin.macro';
import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ArrowLeftIcon as ArrowLeft } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
  disableBackButton?: boolean;
  onBack?: () => void;
}

export function MobileSubHeader(props: Props) {
  const navigate = useNavigate();
  const { children, onBack = () => navigate(-1) } = props;
  return (
    <div tw="my-2 px-6 md:hidden flex justify-between items-center gap-2">
      {!props.disableBackButton && (
        <Button
          type="button"
          outlined
          large
          onClick={() => {
            onBack();
          }}
          icon={ArrowLeft}
        />
      )}
      {children}
    </div>
  );
}
